import React, { useContext, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { basicDetail, initialBasicDetail, inputStyle, statusMapping } from './constant';
import AInput from '../../../../manage/common/formFeilds/customInput/AInput';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import { ReactComponent as EditIcon } from "assets/img/svg/EditBlackIcon.svg";
import { FaCheckSquare } from 'react-icons/fa';
import { validatePincode } from './utils';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { RolePermissions } from 'appContext';
import { PermissionContext } from 'appContext';
import { pages } from 'views/pages/manage/common/constant';
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "../../../../../../assets/img/svg/upwardArrow.svg";
import moment from 'moment';
import { Tooltip } from '@mui/material';
const BasicDetail = ({
    basicDetailRowFormHandler,
    basicForm,
    dropdown,
    setBasicForm,
    isView,
    editSaveHandler,
    rowForm,
    setRowForm,
    branchMappingRows,
    activeContactRows,
    rows
}) => {
    const [isEdit, setIsEdit] = useState(false)
    const [open, setOpen] = useState(true)
    const userPermissions = RolePermissions(
        useContext(PermissionContext),
        pages["schoolMaster"]["id"]
    );
    const getFormatCol = (value = '', label = '', flag = false, index) => {
        return <div className='large-semi-bold label-color' style={value?.label == 'ACTIVE' ? { color: '#05945B' } : {}}>
            {/* {(value&&)?Array.isArray(value)?value.join(', '):value:'N/A'} */}
            {/* <Tooltip title={value ? value?.label ? statusMapping?.[value?.label]??value?.label : value : '-'}>
                                <div className={`ellipsis-text-container`}> */}
            {value ? value?.label ? statusMapping?.[value?.label] ?? value?.label : value : '-'}</div>
        //     </Tooltip>
        // </div>


    }

    const getVal = (col, index, form, setForm) => {
        switch (col?.colType) {
            case "input":
                return <AInput
                    key={`${index}-${col?.colKey}`} // Ensure unique key
                    type="text"
                    value={form?.[col?.colKey] || ""} // Dynamically access value
                    handler={(value) => {

                        basicDetailRowFormHandler(col?.colKey, value, setForm)
                        col?.colKey == 'pincode' && validatePincode(value, setForm, dropdown)
                    }}
                    disabled={col.disabled} // Modify if needed
                    placeholder="Enter"
                    regex={col.regex}
                    //style={selectStyles.control}
                    rightCustomIcon={col?.colKey == 'pincode' && <FaCheckSquare style={{
                        color: (!(form?.[col?.colKey] && (form?.[col?.colKey]).length == 6 && form?.isValidPin)) ? '#D3D3D3' : '#00B0F5', backgroundColor: '#FFF', fontSize: '20px', top: '3px', right: '5px',
                        position: "absolute",
                        bottom: "0",
                        margin: "auto 0",
                        cursor: form?.[col?.colKey] && (form?.[col?.colKey]).length == 6 ? "pointer" : "not-allowed",
                    }}
                    />}
                    //onClick={()=>{validatePincode(basicForm[col?.colKey])}}
                    style={inputStyle}
                    maxLength={col?.maxLength}
                /> // Error
            case "select":
                return <AAutoComplete
                    placeholder="Select"
                    currentValue={form?.[col?.colKey]}
                    handleChange={(value) => {
                        basicDetailRowFormHandler(col?.colKey, value, setForm)
                    }}
                    items={dropdown?.[col?.colKey]}
                    isMulti={false}
                    isShowCount={false}
                    style={{ control: inputStyle }}
                    isInputChange={true}
                    isDisabled={col.disabled}
                />; // Warning
            case "date":
                return <CustomDatePickerV2
                    style={{ input: inputStyle }}
                    placeHolder="Select date"
                    value={form?.[col?.colKey]}
                    handler={(index, date) => {
                        basicDetailRowFormHandler(col?.colKey, date, setForm)
                    }}
                    isStartDate={true}
                    // minDate={moment(new Date(), "DD-MM-YYYY").subtract(1, "months")}
                    // maxDate={new moment(new Date())}
                    disabled={col?.disabled}
                />
            default:
                return <></>
        }
    }
    const enableEdit = () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg)
        }
        else {
            const { id, name, status, board, longDescription, shortDescription, type, medium, effectiveDate, pincode, country, state, city, address } = basicForm
            setRowForm({ schoolId: id, id, name, status, board, longDescription, shortDescription, type, medium, effectiveDate, pincode, country, state, city, address, isValidPin: true })
            setIsEdit(true)
        }
    }
    const checkDisable = () => {
        return !(Object.values(rowForm).every(value => value != null && value !== undefined && value != ''))
    }
    return (
        <Card>
            <CardBody>
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='dark-text label-color'>Basic Detail</div>
                    <div className='d-flex justify-content-between align-items-center'>
                    {open &&((userPermissions?.includes("C") || userPermissions?.includes("U")) && (isView ? !isEdit ? <span className='cursor'><EditIcon onClick={() => enableEdit()} /></span>
                        :
                        <div>
                            <AButton
                                variant="danger_filled"
                                className="button_remove_left_margin"
                                onClick={() => {
                                    setIsEdit(false)
                                    setRowForm({})
                                }}
                            >
                                Discard
                            </AButton>
                            <AButton
                                variant="primary_filled"
                                // className="w-full"
                                onClick={() => {
                                    editSaveHandler(rowForm,rowForm,
                                        {
                                            isBasicFieldsChanged:true,
                                            isContactsChanged:false,
                                            isBranchMappingChanged:false
                                        }
                                    )
                                    setRowForm({})
                                    setIsEdit(false)
                                }}
                                disabled={checkDisable()}
                            >
                                Save
                            </AButton>
                        </div> : <></>
                    ))}
                     <div className='ml-3  p-2 br-8 cursor' style={{ border: '1px solid #EEEEEE' }} onClick={() => { setOpen((prev) => (!prev)) }}>{open ? <Uparrow /> : <DownArrow />}</div>
                    </div>
                </div>
                {open && <><div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                <Row>
                    {basicDetail.map((col, index) => {
                        return <Col md={3} className='mt-24'>
                            <div>

                                <div className='tiny-semi-bold label-color mb-1'>
                                    {col?.label}
                                </div>
                                <div className='large-semi-bold label-color'>
                                    {
                                        isView && !isEdit
                                            ? getFormatCol(col?.colKey == 'effectiveDate' ? moment(basicForm?.[col?.colKey]).format('DD/MM/YYYY') : basicForm?.[col?.colKey])
                                            : getVal(col, index, isView ? rowForm : basicForm, isView ? setRowForm : setBasicForm)
                                    }
                                </div>
                            </div>
                        </Col>

                    })}
                </Row >
                </>}

            </CardBody>
        </Card>
    )

}
export default BasicDetail